const getCookie = (
  cookieKey: string,
  returnComplete = false
): string | undefined => {
  const cookies = window.document.cookie
    ? window.document.cookie.split('; ')
    : []

  const match = cookies.find((cookie) => cookie.startsWith(`${cookieKey}=`))

  if (!match) {
    return undefined
  }

  if (returnComplete) {
    return decodeURIComponent(match)
  }

  return decodeURIComponent(match.split('=')[1])
}

const setCookie = (
  cookieKey: string,
  cookieValue: string,
  expireInDays: number
) => {
  const date = new Date(Date.now() + expireInDays * 24 * 60 * 60 * 1000)

  const expires = `expires=${date.toUTCString()}`
  const hostname = window.location.hostname
  const hostParts = hostname.split('.')
  let domainAttribute = ''

  if (hostParts.length >= 2) {
    const baseDomain = hostParts.slice(-2).join('.')
    domainAttribute = `Domain=.${baseDomain}; `
  }

  window.document.cookie = `${cookieKey}=${encodeURIComponent(
    cookieValue
  )}; ${expires}; ${domainAttribute}path=/; Secure`
}

const DY_COOKIE_ID = '_dyid'
const DY_SERVER_COOKIE_ID = '_dyid_server'
const OPTANON_ALERT_BOX_CLOSED_COOKIE_ID = 'OptanonAlertBoxClosed'
const OPTANON_CONSENT_COOKIE_ID = 'OptanonConsent'

export const setDyServerCookie = () => {
  const trySetDyServerCookie = () => {
    const hasOptanonAlertBoxClosedCookie = !!getCookie(
      OPTANON_ALERT_BOX_CLOSED_COOKIE_ID
    )?.length
    const optanonConsentCookie = getCookie(OPTANON_CONSENT_COOKIE_ID, true)
    const hasRequiredConsent =
      !!optanonConsentCookie && optanonConsentCookie.includes('groups=1:1,2:1')
    const hasDeclinedConsent =
      !!optanonConsentCookie && optanonConsentCookie.includes('groups=1:1,2:0')

    const dyIdCookie = getCookie(DY_COOKIE_ID)
    const dyIdServer = getCookie(DY_SERVER_COOKIE_ID)

    if (
      hasOptanonAlertBoxClosedCookie &&
      hasRequiredConsent &&
      dyIdCookie &&
      !dyIdServer
    ) {
      setCookie(DY_SERVER_COOKIE_ID, dyIdCookie, 365)
      return true
    }

    if ((hasOptanonAlertBoxClosedCookie && hasDeclinedConsent) || dyIdServer) {
      return true
    }

    return false
  }

  if (trySetDyServerCookie()) {
    return
  }

  const intervalId = window.setInterval(() => {
    const done = trySetDyServerCookie()

    if (done) {
      window.clearInterval(intervalId)
    }
  }, 500)
}
